import { personInfoFrag } from '../../../../../utils/type/person.common-type';
import { userInfoFrag } from '../../../../../utils/type/user.common-type';

export const getWorksFrag = `
    id
    dateFrom
    dateTo
    folderId
    serviceId
    workType
    person {
        ${personInfoFrag}
    }
    users {
        ${userInfoFrag}
    }
    workData {
        ... on WorkDataSanctionObject {
            date
            sequenceNumber
            data
            reason
            comment
        }
    }
`;
